import { useMemo } from 'react';
import { useTranslation } from '@blocs.i18n';
import { FEATURE_FLAGS, useFeatureExperiment } from '@blocs.features-experiments';
import { OpportunityCostExperimentGroups, PriceFramingLanguageExperimentGroups } from './enums/experimentGroups';

export const usePaywallExperiments = () => {
  const { t } = useTranslation();
  const opportunityCostExperiment = useFeatureExperiment(FEATURE_FLAGS.EXPERIMENT_OPPORTUNITY_COST);
  const priceFramingLanguageExperiment = useFeatureExperiment(FEATURE_FLAGS.EXPERIMENT_PRICE_FRAMING_LANGUAGE);

  const mapOpportunityCostExperimentGroupToIconColor = useMemo(() => {
    return {
      [OpportunityCostExperimentGroups.VariantA]: 'primary',
      [OpportunityCostExperimentGroups.VariantB]: 'warningInverted',
      [OpportunityCostExperimentGroups.VariantC]: 'danger',
    };
  }, []);

  const mapOpportunityCostExperimentGroupToBgColor = useMemo(() => {
    return {
      [OpportunityCostExperimentGroups.VariantA]: 'info',
      [OpportunityCostExperimentGroups.VariantB]: 'warningInverted',
      [OpportunityCostExperimentGroups.VariantC]: 'danger',
    };
  }, []);

  const bannerIconColor = mapOpportunityCostExperimentGroupToIconColor[opportunityCostExperiment];
  const bannerBgColor = mapOpportunityCostExperimentGroupToBgColor[opportunityCostExperiment];
  const testimonials = useMemo(
    () => [
      {},
      {
        author: 'Jay Ellis',
        message: t('common:paywall.testimonial.message.jay'),
        image: 'jay.png',
        memberSince: '2019',
        id: 'jay',
      },
      {
        author: 'Ken Holmes',
        message: t('common:paywall.testimonial.message.ken'),
        image: 'ken.png',
        memberSince: '2019',
        id: 'ken',
      },
    ],
    [t]
  );
  const customPaywallTitle: string = useMemo(() => {
    if (opportunityCostExperiment && opportunityCostExperiment !== OpportunityCostExperimentGroups.Control) {
      return t('common:paywall.title.opportunityCostExperiment');
    }

    const priceFramingTitles = {
      [PriceFramingLanguageExperimentGroups.VariantA]: 'common:paywall.title.languageExperiment.rolesAndDay',
      [PriceFramingLanguageExperimentGroups.VariantB]: 'common:paywall.title.languageExperiment.accessToRoles',
    };

    return priceFramingLanguageExperiment ? t(priceFramingTitles[priceFramingLanguageExperiment] || '') : '';
  }, [opportunityCostExperiment, priceFramingLanguageExperiment, t]);

  return { bannerIconColor, bannerBgColor, customPaywallTitle, testimonials };
};
